import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram } from "lucide-react";
import { DIVISION_LIST } from "@/data/divisions";

const SOCIALS = [
  { label: "@trans-disimil", href: "https://www.instagram.com/trans-disimil" },
  { label: "@logis.deportiva", href: "https://www.instagram.com/logis.deportiva" },
  { label: "@ciudad.garaje", href: "https://www.instagram.com/ciudad.garaje" },
];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-[#06090D]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-xs font-bold tracking-[0.35em] text-slate-100">
                GRUPO
              </span>
              <span className="font-serif text-3xl font-bold text-gold-gradient">Disimil</span>
            </div>
            <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-slate-400">
              Consorcio empresarial dedicado a ofrecer excelencia en cada detalle: servicios
              corporativos, logística, protocolo VIP y gastronomía.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-gold">
              Divisiones
            </p>
            <ul className="mt-5 space-y-3">
              {DIVISION_LIST.map((d) => (
                <li key={d.slug}>
                  <Link
                    to={d.path}
                    data-testid={`footer-link-${d.slug}`}
                    className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                  >
                    {d.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-gold">
              Contacto
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-gold/70" />
                Venezuela
              </li>
              <li>
                <a
                  href="mailto:contacto@grupodisimil.com"
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
                >
                  <Mail className="h-4 w-4 text-gold/70" />
                  contacto@grupodisimil.com
                </a>
              </li>
            </ul>

            <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.28em] text-gold">
              Síguenos
            </p>
            <ul className="mt-4 space-y-2.5">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-instagram${s.label.replace(/[^a-z0-9]+/g, "-")}`}
                    className="flex items-center gap-3 text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                  >
                    <Instagram className="h-4 w-4 text-gold/70" />
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-line pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
            © 2026 Grupo Disimil — Consorcio Empresarial
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-600">
            Excelencia en cada detalle
          </p>
        </div>
      </div>
    </footer>
  );
}
